<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseOrder.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('purchaseOrder.pageTitle'),
          href: '/admin/purchase-orders'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList v-model="model" :validate="errors" class="ts-border ts-rounded" />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                <ts-button @click.prevent="$router.push({ name: 'purchase-order-v2' })">{{ $t('cancel') }}</ts-button>
                <ts-button :waiting="waiting" @click.prevent="onUpdate" color="primary">{{ $t('update') }}</ts-button>
              </div>
            </div>
          </form>
          <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
            <ts-preview-pdf v-model="waiting" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/purchase-order-info.vue'
import ItemList from './components/item-list'

export default {
  name: 'purchaseOrderV2Edit',
  components: {
    Info,
    ItemList
  },
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        po_date: moment().format('DD-MM-YYYY'),
        vendor_id: null,
        description: null,
        reference_no: null,
        purchase_type_id: null,
        credit_day: 0,
        po_detail: []
      }
    }
  },
  computed: {
    ...mapState('purchaseOrderV2/order', ['edit_data'])
  },
  methods: {
    ...mapActions('purchaseOrderV2/order', [
      'getFormViewModel',
      'find',
      'update'
    ]),
    async getPreData({ params, index }) {
      this.loading = true
      this.getFormViewModel({ index: index, params: params })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .then(async () => {
          await this.find(this.$route.params.id).then(() => {
            this.setEditData()
          })
        })
        .finally(() => (this.loading = false))
    },
    onUpdate() {
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.model.po_date = this.edit_data.po_date
      this.model.vendor_id = this.edit_data.vendor_id
      this.model.description = this.edit_data.description
      this.model.reference_no = this.edit_data.reference_no
      this.model.purchase_type_id = this.edit_data.purchase_type_id
      this.model.credit_day = this.edit_data.credit_day
      this.model.po_detail = this.edit_data.details.map(el => ({
        po_id: el.po_id,
        product_id: el.product_id,
        uom_id: el.uom_id,
        uom_cat_id: el.unite_of_measure ? el.unite_of_measure.uom_cat_id : null,
        qty: el.quantity_order,
        maximum_reorder_allow: el.product.maximum_reorder_allow
          ? el.product.maximum_reorder_allow
          : 0,
        alloworder:
          el.quantity_order >
          (el.product.maximum_reorder_allow
            ? el.product.maximum_reorder_allow
            : 0),
        input_currency_id: el.input_currency_id,
        currency_id: el.currency_id,
        fx_rate: el.fx_rate,
        fx_rate_ratio: el.fx_rate_ratio,
        input_cost: el.input_cost,
        cost: el.cost,
        input_discount_rate: el.input_discount_rate,
        discount_rate: el.discount_rate,
        discount_type: el.discount_type,
        input_total_after_discount: el.input_total_after_discount,
        total_after_discount: el.total_after_discount
      }))
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrderV2/order/CLEAR_SETUP')
    next()
  }
}
</script>
